<template>
  <div>
    <!-- <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t('shiftclose') }}</div>
      </div>
    </div>
    <div class="white-wrapper mt-5">
      <table class="table">
        <thead class="bg-light">
          <tr>
            <th class="align-middle">{{ $t('name') }}</th>
            <th class="align-middle">{{ $t('login_date_time') }}</th>
            <th class="align-middle">{{ $t('logout_date_time') }}</th>
            <th class="align-middle">{{ $t('Collection Amount') }}</th>
            <th class="align-middle">{{ $t('System Amount') }}</th>
            <th class="align-middle">{{ $t('Difference Amount') }}</th>
            <th class="align-middle">{{$tc('status', 1) }}</th>
            <th class="align-middle">{{ $t('action') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(shiftsCLoseValue, shiftsCLoseValueIndex) in shiftsCLoseValues"
            :key="shiftsCLoseValueIndex"
          >
            <td class="align-middle">{{ shiftsCLoseValue.operator }}</td>
          
            <td class="align-middle">{{ shiftsCLoseValue.login_date_time | fulldatemonparse }}</td>
            <td class="align-middle">{{ shiftsCLoseValue.logout_date_time | fulldatemonparse }}</td>

            <td class="align-middle">{{ shiftsCLoseValue.collection_amount}}</td>
            <td class="align-middle">{{ shiftsCLoseValue.difference }}</td>
            <td class="align-middle">{{ shiftsCLoseValue.system_amount}}</td>
            <td
              class="align-middle"
            >{{ shiftsCLoseValue.shift_end && shiftsCLoseValue.shift_end === 'Y' ? 'Closed': shiftsCLoseValue.shift_end && shiftsCLoseValue.shift_end === 'N' ? 'Running': '' }}</td>
            <td class="align-middle">
              <div class="d-flex align-items-center justify-content-center">
                <div class="d-flex">
                  <b-dropdown right variant="edit" class>
                    <b-dropdown-item
                      v-if="!(shiftsCLoseValue.shift_end && shiftsCLoseValue.shift_end === 'Y')"
                      @click="goToRoute('/cinema-manager/edit-shift-close', shiftsCLoseValue)"
                    >
                      <span class="edit-pen"></span>
                      {{ $t('edit') }} {{ $t('shiftclose') }}
                    </b-dropdown-item>
                    <b-dropdown-item
                      @click="goToRoute('/cinema-manager/view-shift-close', shiftsCLoseValue)"
                    >
                      <span class="icon-eye"></span>
                      {{ $t('view') }}
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-if="shiftsCLoseValues.length == 0">
          <tr>
            <td colspan="9">
              <div class="h6 my-3 text-center">{{ $t('NoRecords') }}</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>-->

    <b-modal
      hide-footer
      hide-backdrop
      title="Confirm"
      hide-header-close
      id="mymodal"
      ref="test"
    >
      <div>
        <label>
          <h4>Do you really want to update Status?</h4>
        </label>
        <div class="text-right">
          <button
            @click.prevent.stop="okUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            OK
          </button>
          <button
            @click.prevent.stop="cancelUpdateStatus()"
            class="btn-blue mw-auto mr-3"
          >
            Cancel
          </button>
        </div>
      </div>
    </b-modal>

    <div class="page-container">
      <div class="row pb-3">
        <div class="col-6 align-self-center">
          <div class="section-title">{{ $t("movieLicence") }}</div>
        </div>
        <!-- <div class="col-3 align-self-cetner">
          <div class="searchbar-rounded">
            <input
              @input="onSearch"
              v-model="searchValue"
              type="search"
              placeholder="Search"
            />
          </div>
        </div> -->
        <!-- <div class="col-3 align-self-center">
          <div class="d-flex w-100 justify-content-end">
            <button class="btn-transparent">
              <!-- <img src="@/assets/img/icons/primary/printer.svg" height="25" width="25" /> -->
        <!-- <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </button>
            <span class="mx-2"></span>
            <button class="btn-transparent">
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />

            </button>
          </div>
        </div>  -->
      </div>

      <div class="border-top border-bottom py-3 mb-3">
        <!-- <div class="row">
          <div class="col-6 align-self-center">
            <div class="d-flex">
              <button class="btn-transparent">
                <img
                  src="@/assets/img/icons/primary/filter.svg"
                  height="25"
                  width="25"
                />
              </button>

              <span class="mx-2"></span>

              <div class="">
                <div class="input-material">
                  <div class="add-datepicker">
                    <button
                      class="btn-clearDate"
                      v-if="getSelectedDate"
                      v-on:click="onClearDate()"
                    >
                      ✖
                    </button>
                    <Datepicker :monday-first="true"
                      @selected="onSelectDate($event)"
                      ref="programaticOpen"
                      :value="getSelectedDate"
                      v-validate="'required'"
                      :typeable="true"
                    ></Datepicker>
                    <label :class="getSelectedDate ? 'active' : ''">{{
                      $t("date")
                    }}</label>
                  </div>
                </div>
             
              </div>
            </div>
          </div>
     
        </div> -->
        <div class="row justify-content-between">
          <div class="col-4 align-self-cetner">
            <div class="searchbar-rounded">
              <input v-model="searchValue" type="search" 
              :placeholder="$t('search')" />
            </div>
          </div>

          <div class="col-8 d-flex justify-content-end" style="flex-wrap:wrap;">
          <div class="col-4 align-self-cetner">
            <multiselect
              :options="SearchLicenceList"
              :searchable="true"
              v-model="searchType"
              :placeholder="$tc('searchType')"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
          <div class="col-2 align-self-cetner">
            <button class="btn-blue" @click="onSearch">
              {{ $t("search") }}
            </button>
          </div>

          </div>


          </div>

          <div class="col-12 mt-2">
            <div class="row justify-content-center">
            <b-pagination
              :total-rows="rows"
              :per-page="perPage"
              v-model="currentPage"
              aria-controls="my-table"
              class="mb-0 justify-content-center"
              @change="onChangePagination($event)"
              v-if="movieDetailList && movieDetailList.length > 0"
            ></b-pagination>
            </div>
          </div>
        
      </div>

      <div class="row">
        <div class="data-listing-table">
          <header>
            <div class="row">
              <div class="col-2 align-self-center text-left">
                {{ $t("movieName") }}
              </div>
              <div class="col align-self-center">
                {{ $t("License Start Date") }}
              </div>
              <div class="col align-self-center">
                {{ $t("License End Date") }}
              </div>
              <div class="col align-self-center">
                {{ $t("showType") }}
              </div>
              <!-- <div class="col align-self-center">
                {{ $t("Collection Amount") }}
              </div>
              <div class="col align-self-center">{{ $t("System Amount") }}</div>
              <div class="col align-self-center">
                {{ $t("Difference Amount") }}
              </div> -->
              <!-- <div class="col align-self-center">{{ $tc("status", 1) }}</div> -->
              <div class="col align-self-center">{{ $t("action") }}</div>
              <div class="col align-self-center">{{ $t("collapse") }}</div>
            </div>
          </header>

          <div class="data-body" v-if="movieDetailList.length > 0">
            <div
              class="data-row"
              :key="shiftsCLoseValueIndex"
              v-for="(shiftsCLoseValue,
              shiftsCLoseValueIndex) in movieDetailList"
            >
              <div class="row">
                <div class="col-2 text-left">
                  <p>{{ shiftsCLoseValue.movie_title }}</p>
                </div>
                <div class="col">
                  <input
                    type="date"
                    placeholder="Licence Start Date"
                    v-model="shiftsCLoseValue.licence_start_date"
                  />
                </div>
                <div class="col">
                  <p>
                    <input
                      type="date"
                      placeholder="Licence End Date"
                      v-model="shiftsCLoseValue.licence_end_date"
                    />
                  </p>
                </div>
                <div class="col">
                  <div
                    class="form-check"
                    v-for="(item, showTypeIndex) in ShowTypeArray"
                    :key="showTypeIndex"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      :checked="
                        shiftsCLoseValue.selectShowType.findIndex(
                          x => x.booking_type_id == item.booking_type_id
                        ) !== -1
                      "
                      :id="`showtype${shiftsCLoseValueIndex}${showTypeIndex}`"
                      @change="saveShowType(item, shiftsCLoseValue)"
                    />
                    <label
                      class="form-check-label"
                      :for="`showtype${shiftsCLoseValueIndex}${showTypeIndex}`"
                    >
                      {{ item.screening_name }}
                    </label>
                  </div>
                </div>
                <div class="col">
                  <button
                    class="btn-blue"
                    @click="SaveSchedule(shiftsCLoseValue)"
                  >
                    {{ $t("save") }}
                  </button>
                </div>
                <!-- <div class="col">
                  <p>{{ shiftsCLoseValue.collection_amount }}</p>
                </div> -->
                <!-- <div class="col">
                  <p>{{ shiftsCLoseValue.system_amount }}</p>
                </div> -->
                <!-- <div class="col">
                  <p>{{ shiftsCLoseValue.difference }}</p>
                </div> -->
                <!-- <div class="col">
                  <p
                    :class="[
                      shiftsCLoseValue.shift_end === 'Y'
                        ? 'text-danger'
                        : 'text-success',
                    ]"
                  >
                    {{
                      shiftsCLoseValue.shift_end &&
                      shiftsCLoseValue.shift_end === "Y"
                        ? "Closed"
                        : shiftsCLoseValue.shift_end &&
                          shiftsCLoseValue.shift_end === "N"
                        ? "Running"
                        : ""
                    }}
                  </p>
                </div> -->
                <div class="col">
                  <div class="d-flex w-100 justify-content-between">
                    <!-- <button
                      v-if="shiftsCLoseValue.shift_end == 'Y'"
                      class="btn-transparent"
                      @click="
                        goToRoute(
                          '/cinema-manager/view-shift-close',
                          shiftsCLoseValue
                        )
                      "
                    >
                      <img
                        src="@/assets/img/icons/eye.svg"
                        height="20"
                        width="20"
                      />
                    </button> -->
                    <!-- <button
                      v-if="shiftsCLoseValue.shift_end == 'Y'"
                      class="btn-transparent"
                      @click="
                        goToRoute(
                          '/cinema-manager/update-shift-close',
                          shiftsCLoseValue
                        )
                      "
                    >
                      <img
                        src="@/assets/img/icons/primary/edit.svg"
                        height="20"
                        width="20"
                      />
                    </button> -->
                    <!-- <button
                      v-if="shiftsCLoseValue.shift_end !== 'Y'"
                      class="btn-transparent"
                      @click="
                        goToRoute(
                          '/cinema-manager/edit-shift-close',
                          shiftsCLoseValue
                        )
                      "
                    >
                      <img
                        src="@/assets/img/icons/primary/edit.svg"
                        height="20"
                        width="20"
                      />
                    </button> -->
                    <!-- <div v-else>-</div> -->
                    <button
                      class="btn-transparent"
                      v-b-toggle="'extraData-' + shiftsCLoseValueIndex"
                    >
                      <img
                        src="@/assets/img/icons/primary/chevron-down.svg"
                        height="24"
                        width="24"
                      />
                    </button>
                  </div>
                </div>
              </div>

              <b-collapse
                :id="'extraData-' + shiftsCLoseValueIndex"
                class="movie-license-collapse"
              >
                <div class="d-flex align-items-center">
                  <div class="mr-3">
                    <p>Select Cinema</p>
                    <div
                      v-for="regionObj in CinemasGroupedByRegion"
                      :key="regionObj[0]"
                      v-if="regionObj[1].length > 0"
                      class="my-1"
                    >
                      <div class="d-flex align-items-center my-1">
                        <p
                          class="m-0 cursor-pointer"
                          @click="
                            onClickCinemaRegion(regionObj[1], shiftsCLoseValue)
                          "
                        >
                          {{ regionObj[1][0].region_name }}:
                        </p>

                        <div class="d-flex ml-1">
                          <b-button
                            v-for="(cinema, cinemaIndex) in regionObj[1]"
                            :key="cinemaIndex"
                            :class="`mx-1 cursor-pointer custom-button`"
                            @click="onClickCinemaPill(cinema, shiftsCLoseValue)"
                            :variant="
                              shiftsCLoseValue.selected_cinema.findIndex(
                                x => x.cine_id == cinema.cine_id
                              ) !== -1
                                ? 'primary'
                                : 'outline-primary'
                            "
                            >{{ cinema.cine_code }}</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div class="col-3">
                    <p>Show Type</p>

                    <div class="d-flex ml-1" style="flex-direction: column">
                      <b-button
                        v-for="(item, index_s) in ShowTypeArray"
                        :key="index_s"
                        :class="`mx-1 cursor-pointer custom-button  mb-2`"
                        @click="saveShowType(item, shiftsCLoseValue)"
                        :variant="
                          shiftsCLoseValue.selectShowType.findIndex(
                            x => x.booking_type_id == item.booking_type_id
                          ) !== -1
                            ? 'primary'
                            : 'outline-primary'
                        "
                        >{{ item.screening_name }}</b-button
                      >
                    </div>
                  </div> -->
                  <!-- <div class="col-2">
                    <p>Start Time</p>
                    <div class="custom-timepicker">
                      <div>
                        <vue-timepicker
                          manual-input
                          v-model="shiftsCLoseValue.start_time"
                          id="showtime"
                          name="showtime"
                          format="HH:mm"
                          class="time_picker"
                          input-width="100%"
                          auto-scroll
                          lazy
                          v-validate="'required'"
                        ></vue-timepicker>
                      </div>
                    </div>
                    <p class="mt-2">End Time</p>
                    <div class="custom-timepicker">
                      <div>
                        <vue-timepicker
                          manual-input
                          v-model="shiftsCLoseValue.end_time"
                          id="showtime"
                          name="showtime"
                          format="HH:mm"
                          class="time_picker"
                          input-width="100%"
                          auto-scroll
                          lazy
                          v-validate="'required'"
                        ></vue-timepicker>
                      </div>
                    </div>
                  </div> -->
                  <div class="col-2">
                    <p>{{ $t("intervaltime") }}</p>
                    <div class="custom-timepicker">
                      <vue-timepicker
                        :minute-interval="5"
                        format="mm"
                        name="intervalTIme"
                        id="intervalTIme"
                        manual-input
                        class="time_picker"
                        v-validate="'required'"
                        v-model="shiftsCLoseValue.interval_time"
                      >
                      </vue-timepicker>
                    </div>
                  </div>
                </div>
                <!-- <div class="d-flex justify-content-center">
                  <button
                    class="btn-blue"
                    @click="SaveSchedule(shiftsCLoseValue)"
                  >
                    {{ $t("save") }}
                  </button>
                </div> -->
                <!-- <div class="row mt-2">
                  <div
                    class="col-12"
                    v-if="getIntervals(shiftsCLoseValueIndex)"
                  >
                    <b-badge
                      pill
                      style="
                        margin-left: 2px;
                        margin-bottom: 2px;
                        color: #fff;
                        background-color: #007bff;
                        padding: 7px;
                      "
                      variant="primary"
                      v-for="(item_badge, index_bad) in getIntervals(
                        shiftsCLoseValueIndex
                      )"
                      :key="index_bad"
                      >{{ item_badge }}
                    </b-badge>
                  </div>
                </div> -->
              </b-collapse>
            </div>
          </div>
          <div v-else>
            <!-- No Records Found -->
            <NoRecords />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CinemasService from "@/services/CinemasService";
import MasterService from "@/services/MasterService";
import { uniqBy, throttle, debounce } from "lodash";
import VueTimepicker from "vue2-timepicker";
import MyCinemaService from "@/services/MyCinemaService";
import "vue2-timepicker/dist/VueTimepicker.css";
import Multiselect from "vue-multiselect";

import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    NoRecords,
    VueTimepicker,
    Multiselect
  },
  data() {
    return {
      cinema_id: null,
      shiftsCLoseValues: [],
      submitted: "N",
      debounce: null,
      src_id2: null,
      manager_user_id2: null,
      status: "Y",
      payloadStatus: "Y",
      searchValue: "",
      selectedIndex: null,
      getSelectedDate: null,
      //
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      viewingnumbers: [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 }
      ],
      movieDetailList: [],
      Cinemas: [],
      CinemasGroupedByRegion: [],
      ShowTypeArray: [
        {
          booking_type_id: "1",
          screening_name: "Confirmed Screening"
        },
        {
          booking_type_id: "2",
          screening_name: "CrowdSource Screening"
        },
        {
          booking_type_id: "3",
          screening_name: "Private Screening"
        }
      ],
      SearchLicenceList: ["All", "Licenced", "UnLicenced"],
      searchType: "All"
    };
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    this.cinema_id = obj;
    // this.getShiftCloseList({});
    this.getMovieDetailList();
    this.getCinemasList();

    const { user_id, role_name } = this.secureStore.get("USINFO");
    console.log("role nammee", role_name);
  },
  mounted() {},
  methods: {
    SaveSchedule(scheduleDetail) {
      console.log(scheduleDetail);

      let cinema_id_new=[];
      if(scheduleDetail.selected_cinema.length>0){
        scheduleDetail.selected_cinema.map(z=>{
        cinema_id_new.push(z.cine_id)
        })

      }

 
      if (!scheduleDetail.licence_start_date) {
        this.$toasted.show("Please Select Licence Start Date");
        return false;
      }
      if (!scheduleDetail.licence_end_date) {
        this.$toasted.show("Please Select Licence End Date");
        return false;
      }
      // console.log(
      //   scheduleDetail.licence_end_date,
      //   scheduleDetail.licence_start_date,
      //   moment(scheduleDetail.licence_end_date).isBefore(
      //     scheduleDetail.licence_start_date
      //   )
      // );
      if (
        moment(scheduleDetail.licence_end_date).isBefore(
          scheduleDetail.licence_start_date
        )
      ) {
        this.$toasted.show("License End Date Should be grater than Start Date");
        return false;
      }
      if (
        !scheduleDetail.selected_cinema ||
        scheduleDetail.selected_cinema.length == 0
      ) {
        this.$toasted.show("Please Select Cinema");
        return false;
      }

      if (
        !scheduleDetail.selectShowType ||
        scheduleDetail.selectShowType.length == 0
      ) {
        this.$toasted.show("Please Select Show Type");
        return false;
      }

      let showTypeArray=Array.prototype.map
                .call(scheduleDetail.selectShowType, function(item) {
                  return item.booking_type_id;
                })
                .join(",");

           let movieDetailUpdate={
                  is_confirmed_show:
                              showTypeArray.includes("1")
                                ? "Y"
                                : "N",
                            is_private_show: showTypeArray.includes(
                              "3"
                            )
                              ? "Y"
                              : "N",
                            is_crowd_show: showTypeArray.includes(
                              "2"
                            )
                              ? "Y"
                              : "N",
        md_licence_end_date:scheduleDetail.licence_end_date,
        md_licence_start_date:scheduleDetail.licence_start_date,
        cinema_details:cinema_id_new.length>0?cinema_id_new.join(","):null
      };

      if (!scheduleDetail.interval_time) {
        this.$toasted.show("Please Select Interval Time");
        return false;
      }
      let loader = this.$loading.show();
      let MulScheduleCinemaArray = [];
       let is_private_show=true;
                  let is_confirmed_show=true;
                  let is_crowd_show=true;
                  let showTypeArrayNew= Array.prototype.map
                                  .call(scheduleDetail.selectShowType, function(
                                    item
                                  ) {
                                    return String(item.booking_type_id);
                                  });
      
      scheduleDetail.selected_cinema.map(x => {
        let cinema_obj = {
          cinema_id: x.cine_id,
          category_id: 1,
          sch_start_date: scheduleDetail.licence_start_date,
          sch_end_date: scheduleDetail.licence_end_date,
          MultipleSchedule: []
        };
        x.screen_array.map(y => {
          if(y.is_default_screen=='Y'){
               let newArray=[...showTypeArray];
               let filterModule = cinema_obj.MultipleSchedule.findIndex(scree => {
            return scree.screen_id == y.screen_id;
          });
          if (filterModule < 0) {
              if(y.is_confirmed_show=='N' || x.is_confirmed_show=='N'){
                      is_confirmed_show=false;
                     
                      let index_crowd=newArray.indexOf("1");
                      if(index_crowd>=0){
                        newArray.splice(index_crowd,1)
                      }
                    }
                     if(y.is_crowd_show=='N' || x.is_crowd_show=='N'){
                      is_crowd_show=false;
                     

                       let index_crowd=newArray.indexOf("2");
                       if(index_crowd>=0){

                        newArray.splice(index_crowd,1)
                      }
                    }
                        if(y.is_private_show=='N' || x.is_private_show=='N'){
                        is_private_show=false;
                      

                        let index_crowd=newArray.indexOf("3");
                        if(index_crowd>=0){
                          newArray.splice(index_crowd,1)
                        }
                      }
            let screen_obj = {
              screen_id: y.screen_id,
              selectShowType: newArray
                .join(","),

              moviesArray: [
                {
                  privateRateCard: {
                    rate_card_id: y.rc_id_private,
                    rate_card_group_id: y.rate_card_private_id
                  },

                  cleaning_time_in_mins: x.cine_cleaning_time_in_mins,
                  interval_time_in_mins: x.cine_interval_time_in_mins,
                  ads_time_in_mins: x.cine_setting_ads_time_in_mins,
                  movie_details_id: scheduleDetail.md_id,
                  min_seats: y.min_seats,
                  booked_seats: 0,
                  gogo_user_id: 0,
                  ss_category_id: 0,
                  start_time: y.start_date_time,
                  end_time: y.end_date_time,
                  interval_time: scheduleDetail.interval_time,
                  is_monday: y.is_monday,
                  is_tuesday: y.is_tuesday,
                  is_wednesday: y.is_wednesday,
                  is_thursday: y.is_thursday,
                  is_friday: y.is_friday,
                  is_saturday: y.is_saturday,
                  is_sunday: y.is_sunday,
                  scheduling_price: [
                    {
                      screen_seat_type_id: y.screen_seat_type_id,
                      rate_card_id: y.rc_id,
                      rate_card_private_id: 0,
                      rate_card_group_id: y.rate_card_id
                    }
                  ]
                }
              ]
            };
            cinema_obj.MultipleSchedule.push(screen_obj);
          } else {
            let findIndexNew = cinema_obj.MultipleSchedule[
              filterModule
            ].moviesArray.findIndex(mov => {
              return (
                mov.start_time == y.start_date_time &&
                mov.end_time == y.end_date_time
              );
            });
            if (findIndexNew < 0) {
              let Movieobj = {
                privateRateCard: {
                  rate_card_id: y.rc_id_private,
                  rate_card_group_id: y.rate_card_private_id
                },
                cleaning_time_in_mins: x.cine_cleaning_time_in_mins,
                interval_time_in_mins: x.cine_interval_time_in_mins,
                ads_time_in_mins: x.cine_setting_ads_time_in_mins,
                movie_details_id: scheduleDetail.md_id,
                min_seats: y.min_seats,
                booked_seats: 0,
                gogo_user_id: 0,
                ss_category_id: 0,
                start_time: y.start_date_time,
                end_time: y.end_date_time,
                interval_time: scheduleDetail.interval_time,
                is_monday: y.is_monday,
                is_tuesday: y.is_tuesday,
                is_wednesday: y.is_wednesday,
                is_thursday: y.is_thursday,
                is_friday: y.is_friday,
                is_saturday: y.is_saturday,
                is_sunday: y.is_sunday,
                scheduling_price: [
                  {
                    screen_seat_type_id: y.screen_seat_type_id,
                    rate_card_id: y.rc_id,
                    rate_card_private_id: 0,
                    rate_card_group_id: y.rate_card_id
                  }
                ]
              };
              cinema_obj.MultipleSchedule[filterModule].moviesArray.push(
                Movieobj
              );
            } else {
              cinema_obj.MultipleSchedule[filterModule].moviesArray[
                findIndexNew
              ].scheduling_price.push({
                screen_seat_type_id: y.screen_seat_type_id,
                rate_card_id: y.rc_id,
                rate_card_private_id: 0,
                rate_card_group_id: y.rate_card_id
              });
            }
          }
          }
       
        });

        MulScheduleCinemaArray.push(cinema_obj);
      });

      console.log("MulScheduleCinemaArray", MulScheduleCinemaArray);
      let payload = {
        md_id: scheduleDetail.md_id,
        CinemaSchedule: MulScheduleCinemaArray,
        movie_obj:movieDetailUpdate
      };
      MyCinemaService.addMovieLicenceSchedule(payload).then(result => {
        const { data } = result;
        loader.hide();
        if (data.status) {
          // if (action == "INSERT") {
          this.$toasted.show(data.message);
          // this.resetHandler();
          // this.$router.push({
          //   path: "/cinema-manager/view-schedule",
          // });
          // }
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    getIntervals(movieIndex) {
      let start_time = this.movieDetailList[movieIndex]["start_time"];
      let end_time = this.movieDetailList[movieIndex]["end_time"];
      let interval_time = this.movieDetailList[movieIndex]["interval_time"];

      start_time = new Date(
        moment(start_time, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      end_time = new Date(
        moment(end_time, "HH:mm").format("YYYY-MM-DD, HH:mm:ss")
      );
      console.log(start_time, end_time, moment(end_time).isAfter(start_time));

      if (
        start_time &&
        end_time &&
        interval_time &&
        moment(end_time).isAfter(start_time)
      ) {
        var start = moment(start_time, "YYYY-MM-DD hh:mm a");
        var end = moment(end_time, "YYYY-MM-DD hh:mm a");

        if (interval_time == "00") {
          interval_time = 60;
        }

        // round starting minutes up to nearest 15 (12 --> 15, 17 --> 30)
        // note that 59 will round up to 60, and moment.js handles that correctly
        start.minutes(Math.ceil(start.minutes() / 15) * 15);

        var result = [];

        var current = moment(start);

        while (current <= end) {
          result.push(current.format("HH:mm"));
          current.add(interval_time, "minutes");
        }
        console.log(result, "fsdfsdfsdfsd");
        return result;
      } else {
        // console.log("fsfsdf");
        return null;
      }
    },
    saveShowType(item, movieItem) {
      let findIndeNew = movieItem["selectShowType"].findIndex(x => {
        return x.booking_type_id == item.booking_type_id;
      });
      if (findIndeNew >= 0) {
        movieItem["selectShowType"].splice(findIndeNew, 1);
      } else {
        movieItem["selectShowType"].push(item);
      }
      console.log(movieItem["selectShowType"], "fdfsdfsd");
    },
    onClickCinemaPill: function(cinema, DistributorItem) {
      console.log("onClickCinemaPill called", cinema, DistributorItem);
      let selected_cinemas = DistributorItem.selected_cinema;
      let doesExist = selected_cinemas.findIndex(
        x => x.cine_id == cinema.cine_id
      );
      if (doesExist !== -1) {
        selected_cinemas.splice(doesExist, 1);
      } else {
        selected_cinemas.push(cinema);
      }

      console.log(
        "DistributorItem.selected_cinema",
        DistributorItem.selected_cinema
      );
    },
    onClickCinemaRegion: function(cinemas, DistributorItem) {
      console.log(cinemas, DistributorItem);
      let selected_cinemas = DistributorItem.selected_cinema;
      const doesAllExist = cinemas.every(c => {
        if (selected_cinemas.findIndex(x => x.cine_id == c.cine_id) > -1) {
          return true;
        }
        return false;
      });

      if (doesAllExist) {
        DistributorItem.selected_cinema = selected_cinemas.filter(x => {
          if (cinemas.findIndex(c => c.cine_id == x.cine_id) > -1) {
            return false;
          }
          return true;
        });
      } else {
        cinemas.forEach(c => {
          if (selected_cinemas.findIndex(x => x.cine_id == c.cine_id) === -1) {
            selected_cinemas.push(c);
          }
        });
      }
    },
    goToRoute: function(path, { usl_id }) {
      this.$router.push({
        path: path,
        query: {
          shift_id: usl_id
        }
      });
    },
    onSetValueSrc_id: function(e, values, Tempstatus, manager_user_id, index) {
      this.src_id2 = values;
      this.manager_user_id2 = manager_user_id;
      this.status = Tempstatus;
      this.selectedIndex = index;
      if (status === "N") {
      } else {
      }
      this.$refs.test.show();
      // this.$nextTick(() => {
      //   this.$forceUpdate();
      // });
    },
    getCinemasList: function(cine_id) {
      this.Cinemas = [];
      let body = {
        tableName: "ms_cinemas",
        cine_is_active: "Y"
      };

      MasterService.GetCinemasMovieLicence()
        .then(resp => {
          const { data } = resp;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;

            this.CinemasGroupedByRegion = _.toPairs(
              _.groupBy(data.Records.filter(x => x.region_id), "region_id")
            );
            console.log(
              "this.CinemasGroupedByRegion",
              this.CinemasGroupedByRegion
            );
          } else {
            this.$toasted.show(data.message || "Opps! Something went wrong");
          }
        })
        .catch(this._CatchError);
    },
    onChangeStatus: function(value, index) {
      const { user_id, role_name } = this.secureStore.get("USINFO");
      if (user_id == value.manager_user_id && role_name == "Super Admin") {
        if (confirm("Do you really want to update?")) {
          CinemasService.UpdateShiftClose(value);
        } else {
          if (this.shiftsCLoseValues[index].scr_approval_status == "N") {
            this.shiftsCLoseValues[index].scr_approval_status = "N";
          } else {
            this.shiftsCLoseValues[index].scr_approval_status = "Y";
          }
        }
      }
    },
    onSearch() {
      // this.searchValue = event.target.value;
      // setTimeout(() => {
      this.currentPage = 1;

      this.getMovieDetailList();
      // }, 1000);
    },
    getShiftCloseList(params) {
      const { changeDate, newCurrentPage } = params;
      this.shiftsCLoseValues = [];
      let payload = {
        currentPage: changeDate ? newCurrentPage : this.currentPage,
        limit: this.perPage,
        searchValue: this.searchValue,
        date: this.getSelectedDate,
        cinema_id: this.cinema_id
      };
      CinemasService.GetShiftClose(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if (data.Records.length > 0) {
              this.shiftsCLoseValues = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getMovieDetailList() {
      this.movieDetailList = [];
      let payload = {
        currentPage: this.currentPage,
        limit: this.perPage,
        search: this.searchValue,
        searchType: this.searchType
      };
      CinemasService.GetMovieDetailList(payload)
        .then(response => {
          const { data } = response;
          console.log(data);
          if (data && data.status && data.Records.hasOwnProperty("data")) {
            if (data.Records.data.length > 0) {
              this.movieDetailList = data.Records.data;
              console.log(this.movieDetailList);
              if (data.Records.pagination.hasOwnProperty("total")) {
                if (data.Records.pagination.total >= 10) {
                  this.rows = data.Records.pagination.total;
                } else {
                  this.rows = data.Records.pagination.total;
                  this.selectedvalue = data.Records.pagination.total;
                }
              }
            } else {
              this.$toasted.show(data.message);
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onClearDate: function() {
      this.getSelectedDate = null;
      this.getShiftCloseList({});
    },
    onSelectDate: function(value) {
      this.getSelectedDate = moment(value).format("YYYY-MM-DD");
      this.getShiftCloseList({ newCurrentPage: 1, fromDate: true });
    },
    okUpdateStatus() {
      const { user_id, role_name } = this.secureStore.get("USINFO");
      if (this.status == "Y") {
        this.payloadStatus = "N";
      } else {
        this.payloadStatus = "Y";
      }
      if (user_id == this.manager_user_id2 && role_name == "Super Admin") {
        this.$refs.test.hide();
        let payload = {
          scr_id: this.src_id2,
          scr_approval_status: this.payloadStatus
        };
        CinemasService.UpdateShiftClose(payload)
          .then(response => {
            const { data } = response;
            if (data && data.status) {
              this.$toasted.show(data.message);
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
    cancelUpdateStatus() {
      if (
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status == "Y"
      ) {
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "N";
      } else {
        this.shiftsCLoseValues[this.selectedIndex].scr_approval_status = "Y";
      }
      this.$refs.test.hide();
    },
    onChangePagination: function(event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getMovieDetailList();
      } else {
        this.currentPage = event;
        this.getMovieDetailList();
      }
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    }
  }
};
</script>

<style scoped>
.movie-license-collapse {
  background-color: #e6e6f8;
  padding: 8px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/MyCinemaComponents/MultiScheduling/movie-licence.vue